import React, { useState, memo } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

import { Add, Edit, Pages } from '@material-ui/icons';
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardHeader from 'components/Card/CardHeader.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import Button from 'components/CustomButtons/Button.js';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { Link } from 'react-router-dom';

import { Toasty, useToasty } from 'hooks/Toasty';
import { WithApp } from 'contexts/appContext';
import { wsFindBy } from 'services/WService';
import FilterArticle from 'hooks/FilterArticle';
import CardIcon from 'components/Card/CardIcon';
import UpdatePrice from './UpdatePrice';
import { useModal } from 'hooks/useModal';
import UpdateImageModal from './UpdateImageModal';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    display: 'flex',
    justifyContent: 'space-between',
  },
};
const useStyles = makeStyles(styles);

const columns = [
  { Header: '#', accessor: 'id', excelEnabled: false },
  { Header: 'Código', accessor: 'ItemCode', width: 110 },
  { Header: 'Nombre producto', accessor: 'ItemName' },
  { Header: 'Imagen', accessor: 'img', width: 80, excelEnabled: false },
  { Header: 'Cód. proveedor', accessor: 'CardCode', width: 150 },
  { Header: 'Nombre proveedor', accessor: 'CardName' },
  { Header: 'Nombre categoría', accessor: 'logi_category_description' },
  { Header: 'Nombre familia', accessor: 'logi_family_description' },
  { Header: 'Sub Familia', accessor: 'logi_sub_family_description' },
  { Header: 'Línea', accessor: 'logi_line_description' },
  { Header: 'Marca', accessor: 'logi_mark_description' },
  { Header: 'Estado', accessor: 'state', width: 90 },
  { Header: 'Venta', accessor: 'SellItem', width: 80 },
  { Header: 'ListadoVta', accessor: 'disable_sales_listing', width: 110},
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

const ProductTable = memo(
  function (props) {
    const { products, isUpdate, setOpen, listProducts, showNotify, filters } = props;

    if (isUpdate) {
      return (
        <AllowedGuard permission={ConstantPermissions.LOGI_PRODUCTS_UPDATE}>
          <UpdatePrice
            products={products}
            listProducts={() => listProducts(filters)}
            showNotify={showNotify}
          />
        </AllowedGuard>
      );
    }

    return (
      <ReactTable
        excelName="Productos"
        heightRow={50}
        defaultWidth={2000}
        columns={columns}
        data={products.map((product, i) => {
          return {
            id: (
              <div className="actions-right">
                {i + 1}
                <AllowedGuard permission={ConstantPermissions.LOGI_PRODUCTS_SHOW}>
                  <Button justIcon round simple size="sm">
                    <Link to={`${product.id}`}>
                      <VisibilityIcon />
                    </Link>
                  </Button>
                </AllowedGuard>
              </div>
            ),
            ItemCode: product.ItemCode,
            ItemName: product.ItemName,
            img:
              product.image_sales_path !== null ? (
              <AllowedGuard permission={ConstantPermissions.LOGI_PRODUCTS_UPDATE}>
                <div
                  style={{ width: 40, height: 40, overflow: 'hidden', cursor: 'pointer' }}
                  onClick={() => setOpen(product)}
                >
                  <img src={product.image_sales_path} width={40} />
                </div>
              </AllowedGuard>
              ) : (
              <AllowedGuard permission={ConstantPermissions.LOGI_PRODUCTS_UPDATE}>
                <Button justIcon round color="warning" size="sm" onClick={() => setOpen(product)}>
                  <Edit />
                </Button>
              </AllowedGuard>
              ),
            CardCode: product.CardCode,
            CardName: product.CardName,
            logi_category_description: product.logi_category_description,
            logi_family_description: product.logi_family_description,
            logi_sub_family_description: product.logi_sub_family_description || '-',
            logi_line_description: product.logi_line_description,
            logi_mark_description: product.logi_mark_description,
            SellItem: product.SellItem === 'Y' ? 'Si' : 'No',
            disable_sales_listing: product.SellItem === 'Y' && product.disable_sales_listing === false ? 'Si' : 'No',
            state: product.state === 'A' ? 'Activo' : 'Inactivo',
            actions: '',
          };
        })}
      />
    );
  },
  (prev, next) => {
    return prev.products === next.products && prev.filters === next.filters;
  },
);

export default WithApp(function Product(props) {
  const classes = useStyles();
  const [filters, setFilters] = useState({});
  const [notify, showNotify] = useToasty();
  const [model, setOpen] = useModal();

  const [products, setProducts] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);

  async function listProducts(search) {
    setDataLoading(true);
    let response = await wsFindBy('logi/product', { ...search, allFields: 'N' });
    setDataLoading(false);
    if (response.success) {
      setProducts(response.data);
      setFilters(search);
    }
  }

  return (
    <GridContainer>
      <Toasty action={notify} />
      <UpdateImageModal
        model={model}
        setOpen={setOpen}
        showNotify={showNotify}
        setProducts={setProducts}
      />
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.LOGI_PRODUCTS_STORE}
              component={
                <CardIcon color="primary">
                  <Pages style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <Link to="0">
                <CardIcon pointer="true" color="success">
                  <Add style={{ color: 'white' }} />
                </CardIcon>
              </Link>
            </AllowedGuard>
            <span className={classes.cardIconTitle}>
              <h4>Listado de Productos {dataLoading && <LoadingSpinner />}</h4>
              <Button
                color={
                  !isUpdate ? props.themeContext.buttonColorWarning : props.themeContext.buttonColor
                }
                size="sm"
                onClick={() => setIsUpdate(!isUpdate)}
              >
                {isUpdate ? 'Ver productos' : 'Editar precios'}
              </Button>
            </span>
          </CardHeader>
          <CardBody>
            <FilterArticle getFilter={listProducts} mark />

            <ProductTable
              products={products}
              setOpen={setOpen}
              isUpdate={isUpdate}
              listProducts={listProducts}
              showNotify={showNotify}
              filters={filters}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
